import api from "../../../../services/api"

// Ações de entrega da Pick'n Go (sistemaadm: PickngoResource, /rest/pickngo/entrega/...).
// Todas respondem { sucesso, mensagem, ... }; falhas de rede viram { sucesso: false, mensagem }.

const headers = autorizacao => ({
    "Content-Type": "application/json",
    Authorization: autorizacao,
})

const erroParaResposta = error => ({
    sucesso: false,
    mensagem:
        error?.response?.data?.mensagem ||
        (error?.response ? `Erro ${error.response.status} ao falar com o servidor` : "Verifique sua conexão!"),
})

const post = async (caminho, autorizacao) => {
    try {
        const response = await api.post(caminho, {}, { headers: headers(autorizacao) })
        return response.data || { sucesso: false, mensagem: "Resposta vazia do servidor" }
    } catch (error) {
        return erroParaResposta(error)
    }
}

// Cotação (valor, distância, veículo) sem criar a entrega.
export const cotarEntregaPickngo = (idDoPedido, autorizacao) =>
    post(`pickngo/entrega/cotar/${idDoPedido}`, autorizacao)

// Cria a entrega na Pick'n Go (/fazerpedido). Devolve { sucesso, mensagem, entrega }.
export const solicitarEntregaPickngo = (idDoPedido, autorizacao) =>
    post(`pickngo/entrega/solicitar/${idDoPedido}`, autorizacao)

// Avisa a Pick'n Go que o pedido está pronto para coleta (/marcarpronto).
export const marcarProntoPickngo = (idDoPedido, autorizacao) =>
    post(`pickngo/entrega/pronto/${idDoPedido}`, autorizacao)

// Cancela a entrega na Pick'n Go (/cancelar). Não altera o status do pedido.
export const cancelarEntregaPickngo = (idDoPedido, autorizacao) =>
    post(`pickngo/entrega/cancelar/${idDoPedido}`, autorizacao)

// Entrega mais recente do pedido. atualizar=true consulta a Pick'n Go antes (/listarpedido).
export const buscarEntregaPickngo = async (idDoPedido, autorizacao, atualizar = false) => {
    try {
        const response = await api.get(`pickngo/entrega/detalhe/${idDoPedido}`, {
            headers: headers(autorizacao),
            params: { atualizar },
        })
        return response.data || { sucesso: false, mensagem: "Resposta vazia do servidor" }
    } catch (error) {
        return erroParaResposta(error)
    }
}
